import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Link} from 'react-router';
import {Map, List} from 'immutable';
import {connect} from 'react-redux';
import {registry} from 'records';
import CopyToClipboard from 'react-copy-to-clipboard';
import numeral from 'numeral';
import {imagesAdded} from '../utils/kit';
import DocumentationMixin from '../mixins/DocumentationMixin';
import {MUTATION_TYPE_CREATED} from 'reducers/publish';
import {Request, RequestsMixin, GET} from 'requests';
import {ResourcesMatching, Requesting, Done} from 'requests/components';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import {default as Tooltip} from 'components/Tooltip';

const POPOVER_TIMEOUT = 2000  // in ms

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.kitToken || ownProps.params.kitToken;

  return {
    kitToken,
    requests: state.requests,
    kitMutations: state.kitMutations,
  };
};

const DocumentationImagesController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    requests: PropTypes.object.isRequired,
    kitMutations: ImmutablePropTypes.map,
  },

  mixins: [DocumentationMixin, RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      sizes: Map(),
      loadingFailed: List(),
      cdnUrlCopied: false,
    };
  },

  componentWillMount() {
    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken],
      }),
    });

    this.setRequest({
      publications: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'publications'],
      }),
    });

    this.setRequest({
      workingSetImages: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-images'],
      }),
    });
  },

  resources() {
    const rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').find({token: this.props.kitToken}),
      finishedPublications: rm.type(this.requests.publications, 'publications').all().filter(p => p.status === 'finished'),
      workingSetImages: rm.type(this.requests.workingSetImages, 'working-set-images').all(),
    };
  },

  handleCdnUrlClicked(event) {
    event.target.select();
  },

  handleCdnUrlCopied(workingSetImage) {
    const disable = () => this.setState({cdnUrlCopied: false});

    this.setState({cdnUrlCopied: workingSetImage}, () => {
      setTimeout(disable, POPOVER_TIMEOUT);
    });
  },

  renderImagesInKit() {
    const {cdnUrlCopied} = this.state;
    const {kit, workingSetImages} = this.resources();
    const unpublishedImages = imagesAdded(this.props.kitMutations, this.props.kitToken)
      .map((request) => request.getIn(['record', 'name']));

    const imageElements = workingSetImages
      .filter((workingSetImage) => workingSetImage.status === "finished")
      .filterNot((workingSetImage) => unpublishedImages.includes(workingSetImage.name))
      .sortBy((workingSetImage) => workingSetImage.createdAt.unix())
      .reverse()
      .map((workingSetImage) => {
        const percentLeft = workingSetImage.optimizedSize / workingSetImage.originalSize * 100;
        const handleCdnUrlClicked = (event) => {
          event.target.select();
        };
        const handleCdnUrlCopied = (event) => {
          this.handleCdnUrlCopied(workingSetImage);
        };
        const handleImageLoaded = (event) => {
          this.setState({
            sizes: this.state.sizes.set(workingSetImage.id, [event.target.naturalWidth, event.target.naturalHeight]),
          });
        };
        const handleImageError = () => {
          this.setState({
            loadingFailed: this.state.loadingFailed.push(workingSetImage.id),
          });
        };
        const loadingFailed = this.state.loadingFailed.includes(workingSetImage.id);
        const imageSize = this.state.sizes.get(workingSetImage.id, null);
        const cdnUrlCopied = this.state.cdnUrlCopied === workingSetImage;
        const cdnUrlCopiedPopover = (cdnUrlCopied) ? <Tooltip noIcon={true} content="Link Copied!" /> : null;

        let sizeLabel = (imageSize) ? `${imageSize[0]} x ${imageSize[1]}` : <span>Loading &hellip;</span>;

        let imgElement = (
          <a className="link-dashed-none block text-xs-center" href={workingSetImage.publishedUrl} target="_blank" title="view original file">
            <img onLoad={handleImageLoaded} onError={handleImageError} className="asset-source" src={workingSetImage.publishedUrl} alt={workingSetImage.name} />
          </a>
        );

        if (this.state.loadingFailed.includes(workingSetImage.id)) {
          imgElement = <span><i className="ficon ficon-alert" /> Failed to load this image. Did you publish?</span>;
          sizeLabel = <span>&mdash;</span>;
        }

        return (
          <div key={workingSetImage.id} className="m-xs-b-xl asset asset-image">
            <div className="row">
              <div className="col-xs-6">
                <div className="asset-inner">
                  <div className="asset-preview bg-img-checkered">
                    {imgElement}
                  </div>

                  <div className="image-performance-sm bg-primary-light m-xs-b-sm">
                    <div className="image-performance-value br-r bg-primary" style={{width: `${percentLeft}%`}}></div>
                  </div>

                  <div className="asset-label text-sm row">
                    <div className="col-xs-6">
                      <p className="m-xs-b-0 text-truncate">
                        {workingSetImage.name}
                      </p>
                    </div>

                    <div className="col-xs-6 text-xs-right">
                      <p className="m-xs-b-0">
                        <span className="sr-only">File size: </span>
                        <span className="text-primary">{numeral(workingSetImage.optimizedSize).format('0.0 b')}</span>
                        <span className="text-primary-lighter m-xs-l-xs text-strike">{numeral(workingSetImage.originalSize).format('0.0 b')}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xs-6 p-xs-r-0">
                <table className="table table-condensed text-muted">
                  <tbody>
                    <tr className="asset-dimensions">
                      <th scope="row" className="text-nowrap sr-only">Dimensions</th>
                      <td className="p-xs-x-0 p-xs-t-0 b-t-0">{sizeLabel}</td>
                    </tr>
                    <tr className="asset-cdn-url">
                      <th scope="row" className="text-nowrap sr-only">
                        <span className="m-xs-t-sm block">CDN URL</span>
                      </th>
                      <td className="has-tooltip p-xs-x-0">
                        <div className="gg">
                          <div className="gg-col p-xs-r-md"><input onClick={handleCdnUrlClicked} className="table bg-white form-control-static p-xs-a-0 br-r-0 block b-a-0 text-truncate" defaultValue={workingSetImage.publishedUrl} /></div>
                          <div className="gg-col min-width has-tooltip">
                            {cdnUrlCopiedPopover}

                            <CopyToClipboard text={workingSetImage.publishedUrl} onCopy={handleCdnUrlCopied}>
                              <button className="copy-control btn btn-primary btn-sm">
                                <i className="ficon ficon-copy"></i>
                              </button>
                            </CopyToClipboard>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr className="asset-use">
                      <th scope="row" className="text-nowrap sr-only">HTML use</th>
                      <td className="p-xs-x-0">
                        <div className="well pre bg-gray-dark inset-darkest font-family-monospace m-xs-b-xs p-xs-y-sm text-xs-left text-sm">
                          <div className="code code-highlight word-wrap">
                            <span className="nt">&lt;img</span>&nbsp;<span className="na">src="</span><span className="s">{workingSetImage.publishedUrl}</span><span className="na">"</span>&nbsp;<span className="na">alt=""</span><span className="nt">&gt;</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      });

    const noImagesElement = (
      <div className="well bg-primary bg-img bg-img-icons p-xs-a-2x m-xs-b-lg text-xs-center">
        <h2 className="text-2x">This Kit Doesn't Have Any Images</h2>
        <p className="lead m-xs-b-0 text-muted">Hey. It looks like you don't have any images currently in this kit. Its pretty easy to <Link to={`/kits/${kit.token}/images/upload`} className="text-white">upload some</Link>.</p>
      </div>
    );

    return (
      <section id="kit-components-images-inventory" className="kit-components-images-inventory kit-assets-images kit-assets-images-lg m-xs-b-xl">
        <h2 className="text-2x m-xs-b-0">Images in this Kit</h2>
        <hr className="hr-lg m-xs-y-sm" />
        {(imageElements.isEmpty()) ? noImagesElement : [...imageElements]}
      </section>
    );
  },

  renderUnpublishedChangesAlert() {
    let retval = null;

    const {kitMutations} = this.props;
    const {kit} = this.resources();
    const imagesHaveBeenAdded = !imagesAdded(kitMutations, kit.token).isEmpty();

    if (imagesHaveBeenAdded) {
      retval = (
        <div className="alert alert-primary bg-body has-icon m-xs-b-xl">
          <i className="ficon ficon-lg ficon-warning alert-icon"></i>
          <p className="m-xs-b-0">Hmm, you&apos;ve added some images that you haven&apos;t published yet. <strong>Publish to see them here</strong> and to use them in your project.</p>
        </div>
      );
    }

    return retval;
  },

  renderTroubleshootingImages() {
    return (
      <section id="kit-components-images-troubleshooting" className="kit-components-images-troubleshooting">
        <h2 className="text-2x m-xs-b-0">Troubleshooting Images</h2>
        <hr className="hr-lg m-xs-y-sm" />

        <article className="images-not-rendering m-xs-b-lg" id="images-not-rendering">
          <h3 className="text-lg">My kit&apos;s images aren&apos;t rendering properly on my site or app</h3>
          <p>
            If your images aren&apos;t rendering properly, you&apos;ll want to check the following:
          </p>

          <ul>
            <li>Did you published all changes/updates to you kit?</li>
            <li>Is your markup correct? Both the image URL and the <code>&lt;img /&gt;</code> tag need to be correct.</li>
          </ul>
        </article>
      </section>
    );
  },

  renderMain() {
    const {kit, finishedPublications} = this.resources();

    return (
      <div className="row">
        <div className="col-xs-3 col-xs-push-9 p-xs-l-xl">
          {this.renderNavigation(kit, {hasBeenPublished: !finishedPublications.isEmpty()})}
        </div>
        <div className="col-xs-9 col-xs-pull-3">
          {this.renderUnpublishedChangesAlert()}
          {this.renderImagesInKit()}
          {this.renderTroubleshootingImages()}
        </div>
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="is-loading is-loading-documentation-images m-xs-x-0 bg-body p-xs-a-xl br-a">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  render() {
    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={true} render={this.renderSpinner} />
        <Done all={true} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(DocumentationImagesController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/DocumentationImagesController.js